import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@prism/tooltip';

class PrismTooltip extends React.PureComponent {
    static propTypes = {
        target: PropTypes.string.isRequired,
        className: PropTypes.string,
        size: PropTypes.string,
        placement: PropTypes.string,
        trigger: PropTypes.string,
        toggle: PropTypes.func,
        isOpen: PropTypes.bool,
        targetIsFunctional: PropTypes.bool
    };

    render() {
        const {
            children,
            className,
            ...elementProps
        } = this.props;

        const elementClassName = classNames(
            'prism-tooltip',
            className
        );

        return (
            <Tooltip
                {...elementProps}
                className={elementClassName}
                sandbox
            >
                {children}
            </Tooltip>
        );
    }
}

export default PrismTooltip;
